// extracted by mini-css-extract-plugin
export default {"divider":"yNAfA3i6zxFS7ny9aKJT","line":"JHECgUftWfI5CdoGJqlD","text":"Lk88AHGrE5I1MYmS6fmo"};